/* eslint-disable no-nested-ternary */
import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { TopNav } from "goodera-infinity-gems-test";
import { logoutUser } from "../../../apiFactory/QueryBuilder";
import { findAppContext, findOriginofEvent } from "../../../services/DashboardDesigner/amplitudeService";
import Drawer from "../Drawer";
import { getSecureImage } from "../../../services/DashboardDesigner/widgetService";
import DEPLOYMENT_SETTINGS from "../../../environmentSettings";
import { logAnyPageEvents } from "../../../services/DashboardDesigner/eventActions";
import uniqusLogo from '../../../assets/uniqus-logo.png'
import apiUrlConfig from "../../../environmentSettings"

const reqSvgs =
	process.env.NODE_ENV === "test" ? () => {} : require.context("../../../assets/img", true, /\.svg$/);

const svgs =
	process.env.NODE_ENV === "test"
		? {}
		: reqSvgs.keys().reduce((images, path) => {
				const image = images;
				image[path] = reqSvgs(path);
				return image;
		  }, {});

const handleAppDrawer = (setOpenDrawer, openDrawer) => {
	const origin = findOriginofEvent();
	const app = findAppContext();
	if (openDrawer) {
		logAnyPageEvents.appDrawer_closed({ app }, origin);
	} else {
		logAnyPageEvents.appDrawer_opened({ app }, origin);
	}
	setOpenDrawer(!openDrawer);
};

const handleAppClick = appName => {
	const origin = findOriginofEvent();
	const app = findAppContext();
	logAnyPageEvents.app_clicked({ app, appName }, origin);
};

const getAppCard = (app, domainUrl) => {
	const iconName = app.icon ? app.icon.split("/").pop() : "dashboard.svg";
	const landingRoute = app.id === "p3-canvas" ? `${apiUrlConfig.apiConfig.canvasURL}/` : app.landingRoute;
	return (
		<a
			className="nav-list-border-sliding "
			onClick={() => handleAppClick(app.name)}
			href={
				landingRoute
					? landingRoute.includes("http")
						? landingRoute
						: `${domainUrl}${landingRoute}`
					: null
			}
		>
			<div
				className={`sliding-nav-div ${app.id === "p3-canvas" ? "sliding-nav-theme-font-color" : ""}`}
			>
				<div className="nav-icon-table">
					<span className=" sliding-nav-icon">
						<img className="app-icon-nav" src={svgs[`./${iconName}`]} aria-hidden="true" alt="" />
					</span>

					<span className="sliding-nav-text "> {app.name} </span>
				</div>
			</div>
		</a>
	);
};

export const getAppsDrawerAndLogo = (
	logoUrl,
	openDrawer,
	setOpenDrawer,
	userApps,
	iconColor,
	organization
) => {
	const product = userApps ? Object.keys(userApps) : [];
	// Without this the trigger opens an empty "Switch apps" drawer for users whose
	// licences match no app in the catalog. Keep the logo, drop the drawer + trigger.
	const hasSwitchableApps = product.length > 0;
	const domainUrl =
		organization && organization.customDomain
			? `https://${organization.customDomain}`
			: DEPLOYMENT_SETTINGS.apiConfig.appURL;
	return (
		<>
			<div className="d-flex align-items-center">
				{hasSwitchableApps && (
				<Drawer
					title="Switch apps"
					isOpen={openDrawer}
					toggleDrawer={() => handleAppDrawer(setOpenDrawer, openDrawer)}
					hasForm={false}
					position="left"
					width="300px"
				>
					<div className="side-Apps-Drawer">
						{product.map(element => {
							userApps[element].sort((a, b) =>
								a.name.toLowerCase() > b.name.toLowerCase()
									? 1
									: b.name.toLowerCase() > a.name.toLowerCase()
									? -1
									: 0
							);
							return (
								<div className="">
									<div className="sliding-global-title ">
										<span className="sliding-nav-title ">{element}</span>{" "}
									</div>
									{userApps[element].map(app => getAppCard(app, domainUrl))}
								</div>
							);
						})}
					</div>
				</Drawer>
				)}
				{hasSwitchableApps && (
				<div id="icon" onClick={() => handleAppDrawer(setOpenDrawer, openDrawer)}>
					<i className="icons-Menu-icon" style={{ fontSize: "16px", color: iconColor }} />
				</div>
				)}
				<Link to="/">
					<img src={getSecureImage(logoUrl)} className="logo-img" alt="" />
				</Link>
			</div>
		</>
	);
};

const OrgTopNav = ({ userInfo, userApps, organization }) => {
	const domainUrl =
		organization && organization.customDomain
			? `https://${organization.customDomain}`
			: DEPLOYMENT_SETTINGS.apiConfig.appURL;

	const appsList = [];

	for (const ele in userApps) {
		const apps = userApps[ele].map(app => {
			const landingRoute = app.id === "p3-canvas" ? `${apiUrlConfig.apiConfig.canvasURL}/` : app.landingRoute;
			const iconName = app.icon ? app.icon.split("/").pop() : "dashboard.svg";
			return {
				landingRoute: landingRoute
					? landingRoute.includes("http")
						? landingRoute
						: `${domainUrl}${landingRoute}`
					: null,
				id: app.id,
				iconHref: svgs[`./${iconName}`],
				name: app.name
			};
		});
		appsList.push({
			name: ele,
			apps
		});
	}

	const logOut = () => {
		const origin = findOriginofEvent();
		logAnyPageEvents.logout({}, origin);
		const accessToken = localStorage.getItem("$LoopBack$accessTokenId");
		logoutUser(accessToken).then(() => {
			localStorage.clear();
			const { authServiceUrl, exchangeTokenUrl } = DEPLOYMENT_SETTINGS.apiConfig;
			authLogin(authServiceUrl, exchangeTokenUrl);
		});
	};

	return (
		<div data-cai-context-exclude="true">
			<TopNav
				logo={{
					iconUrl: uniqusLogo,
					href: "/",
					alt: "uniqus"
				}}
				user={{
					info: {
						name: userInfo.name,
						email: userInfo.email,
						href: userInfo.image
					},
					options: [],
					onClick: logOut,
					signOutText: "Sign out"
				}}
				app={{
					products: appsList,
					currentAppId: "p3-canvas",
					onClick: e => handleAppClick(e.target.textContent)
				}}
			/>
		</div>
	);
};

const mapStateToProps = state => ({
	userApps: state.userAppsInfo,
	orgId: state.organizationID,
	userInfo: state.userInfo,
	organization: state.organization
});

export default connect(mapStateToProps)(OrgTopNav);
